import React, { FC, ReactElement } from 'react';
import classNames from 'classnames';
import Alert, { Color } from '@material-ui/lab/Alert';

import AlertTitle from '@material-ui/lab/AlertTitle';
import { SimpleButton } from '../../atoms/SimpleButton';

import { SimpleIconType } from '../../atoms/SimpleIcon';
import useStyles from './styles';

export interface CalloutMessageProps {
  message: string | ReactElement;
  actionLabel?: string;
  title?: string | ReactElement;
  type?: Color;
  actionDisabled?: boolean;
  margin?: boolean;
  onClick?: () => void;
  icon?: SimpleIconType;
  classes?: Record<string, string>;
}

const CalloutMessage: FC<CalloutMessageProps> = (props) => {
  const {
    message,
    actionDisabled = false,
    actionLabel = '',
    title = '',
    type = 'info',
    onClick = null,
    icon = null,
    classes: classesFromProps,
  } = props;

  const styles = Object.values(classesFromProps || {});
  const classes = useStyles(props);

  return (
    <Alert
      severity={type}
      classes={classes}
      className={classNames(...styles)}
      icon={icon}
      action={
        onClick && (
          <SimpleButton
            label={actionLabel}
            onClick={onClick}
            primary
            disabled={actionDisabled}
            className={classes.action}
          />
        )
      }
    >
      {!!title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </Alert>
  );
};

CalloutMessage.defaultProps = {};

export default CalloutMessage;
